import { setOrderDeliveryZone, setSelectedCity } from '../../../actions';
import { identityPayload, createReducer, forAction } from '../../../utils';

const initialState = null;

export default createReducer(
  [
    forAction(setOrderDeliveryZone, identityPayload),
  ],
  initialState,
  [setSelectedCity],
);
